import React, { Component } from "react";

export default class LiteYouTubeEmbed extends Component {
  constructor(props) {
    super(props);
    this.state = { showPlayer: false };
  }

  showPlayer = () => {
    this.setState({ showPlayer: true });
  }

  handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      this.showPlayer();
    }
  }

  render() {
    const {
      videoId,
      title = "Vidéo YouTube",
      aspectRatio = "16/9",
      className = "youtube-lite",
      thumbnail: customThumbnail,
      style = {},
      thumbnailStyle = {}
    } = this.props;
    const thumbnail = customThumbnail || `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

    if (this.state.showPlayer) {
      return (
        <iframe
          width="100%"
          height="555"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
          title={title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          style={Object.assign({ borderRadius: "10px", display: "block", width: "100%", aspectRatio }, style)}
          loading="lazy"
        />
      );
    }

    return (
      <div
        className={className}
        role="button"
        aria-label={`Lire la vidéo : ${title}`}
        tabIndex={0}
        style={Object.assign({
          cursor: "pointer",
          position: "relative",
          maxWidth: 1000,
          margin: "30px auto",
          borderRadius: "10px",
          overflow: "hidden",
          aspectRatio: aspectRatio,
          background: "#000"
        }, style)}
        onClick={this.showPlayer}
        onKeyDown={this.handleKeyDown}
      >
        <img
          src={thumbnail}
          alt={`Miniature ${title}`}
          width="100%"
          height="555"
          style={Object.assign({ display: "block", width: "100%", objectFit: "cover", aspectRatio }, thumbnailStyle)}
          loading="lazy"
        />
        <span
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%,-50%)",
            pointerEvents: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          aria-hidden="true"
        >
          <svg width="68" height="48" viewBox="0 0 68 48">
            <path d="M66.52 7.14c-0.78-2.93-3.07-5.2-6-5.98C56.36 0.21 34 0.21 34 0.21s-22.36 0-26.52 0.96c-2.93 0.78-5.22 3.05-6 5.98C0.5 11.36 0.5 24 0.5 24s0 12.64 0.98 16.86c0.78 2.93 3.07 5.2 6 5.98C11.64 47.79 34 47.79 34 47.79s22.36 0 26.52-0.96c2.93-0.78 5.22-3.05 6-5.98C67.5 36.64 67.5 24 67.5 24s0-12.64-0.98-16.86z" fill="#212121" fillOpacity="0.8" />
            <path d="M45.5 24L27.5 14v20z" fill="#fff" />
          </svg>
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LiteYouTubeEmbed.js